export const engagementLandingPagesSelect = "/engagement/landing_pages/select";
